module.exports = __webpack_public_path__ + "img/gf-select.a5f261a4.jpg";